import { ApiEndpoint } from "@/app/apiEndpoint";
import axios from "@/app/http/axios";
import { ResponsibleConfig, ResponsiblePerson } from "@/interface/ResponsiblePerson.interface";

export default class AdminResponsibleService {
  constructor() {}

  async getAll() {
    const path = ApiEndpoint.AdminResponsiblePerson.GET_ALL;
    try {
      const response = await axios.get<ResponsibleConfig[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getAllWithConditions(filter: any) {
    const path = ApiEndpoint.AdminResponsiblePerson.SEARCH;
    try {
      const response = await axios.post<ResponsibleConfig[]>(`${path}`, filter);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async createResponsibleConfig(value: ResponsibleConfig) {
    const path = ApiEndpoint.AdminResponsiblePerson.CREATE;
    try {
      const response = await axios.post(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async saveResponsibleConfig(departmentCode: string, value: ResponsibleConfig) {
    const path = ApiEndpoint.AdminResponsiblePerson.UPDATE;
    try {
      const response = await axios.patch(
        `${path.replace("{departmentCode}", departmentCode)}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateStatus(departmentCode: string, value: any) {
    const path = ApiEndpoint.AdminResponsiblePerson.UPDATE_STATUS;
    try {
      const response = await axios.patch(
        `${path.replace("{departmentCode}", departmentCode)}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
